import { useEffect } from "react";
import type { PropsWithChildren } from "react";
import { PageLoading } from "../../utils/PageLoading";
import { useDispatch, useSelector } from "react-redux";

import { switchShop } from "legacy/actions/actions";
import { selectCurrShop } from "legacy/containers/App/selectors";
import { useShopSelection } from "./useShopSelection";

export const ShopSwitchReduxBridge = ({ children }: PropsWithChildren) => {
  const dispatch = useDispatch();
  const { selectedShop: projectedMongoShopId, shopId: projectedShopId } =
    useSelector(selectCurrShop);
  const {
    state: { selectedShop }
  } = useShopSelection();

  const mongoShopId = selectedShop?.mongoShopId;
  const shopId = selectedShop?.shopId;

  useEffect(() => {
    if (mongoShopId === undefined || shopId === undefined) return;

    if (projectedMongoShopId !== mongoShopId || projectedShopId?.toString() !== shopId.toString()) {
      dispatch(switchShop(mongoShopId, shopId));
    }
  }, [dispatch, mongoShopId, projectedMongoShopId, projectedShopId, shopId]);

  const reduxMatchesSelectedShop =
    projectedMongoShopId === mongoShopId && projectedShopId?.toString() === shopId?.toString();

  if (!children) return null;
  if (!reduxMatchesSelectedShop) return <PageLoading />;

  return <>{children}</>;
};
